import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import Card from '../../components/Card/Card';
import Button from '../../components/Button/Button';
import DonateButton from '../../components/DonateButton/DonateButton';
import styles from './Donate.module.css';

const Donate = () => {
  return (
    <div className={styles.donate}>
      {/* Hero / Page Header */}
      <section className={styles.header}>
        <h1 className={styles.pageTitle}>Support Our Mission</h1>
        <p className={styles.pageSubtitle}>
          Your generosity brings healthcare and hope to the Idoma nation
        </p>
      </section>

      {/* Impact Summary */}
      <section className={styles.impact}>
        <SectionTitle title="Your Impact" subtitle="Where your money goes" align="center" />
        <div className={styles.impactGrid}>
          <div className={styles.impactItem}>
            <span className={styles.impactNumber}>₦10,000</span>
            <span className={styles.impactLabel}>Provides medicines for 50 patients</span>
          </div>
          <div className={styles.impactItem}>
            <span className={styles.impactNumber}>₦25,000</span>
            <span className={styles.impactLabel}>Funds a health talk at a rural community</span>
          </div>
          <div className={styles.impactItem}>
            <span className={styles.impactNumber}>₦50,000</span>
            <span className={styles.impactLabel}>Supports one issue of our medical journal</span>
          </div>
          <div className={styles.impactItem}>
            <span className={styles.impactNumber}>₦100,000</span>
            <span className={styles.impactLabel}>Sponsors a full-day medical outreach</span>
          </div>
        </div>
      </section>

      {/* Donation Options */}
      <section className={styles.options}>
        <SectionTitle title="Ways to Give" subtitle="Choose how you'd like to donate" align="center" />
        <div className={styles.cardGrid}>
          <Card title="One-Time Donation" variant="elevated">
            <p>Make a single gift to support our ongoing programs and medical outreaches.</p>
            <div className={styles.cardAction}>
              <DonateButton />
            </div>
          </Card>
          <Card title="Monthly Giving" variant="elevated">
            <p>Become a monthly partner and sustain our work year-round with automatic donations.</p>
            <div className={styles.cardAction}>
              <Button variant="primary">Start Monthly</Button>
            </div>
          </Card>
          <Card title="In-Kind Donations" variant="elevated">
            <p>Donate medical supplies, equipment, or volunteer your expertise. Contact us to arrange.</p>
            <div className={styles.cardAction}>
              <Link to="/contact">
                <Button variant="outline">Contact Us</Button>
              </Link>
            </div>
          </Card>
          <Card title="Memorial/Tribute" variant="elevated">
            <p>Honour a loved one with a gift in their name. We'll notify the family of your tribute.</p>
            <div className={styles.cardAction}>
              <Button variant="outline">Give in Honour</Button>
            </div>
          </Card>
        </div>
      </section>

      {/* Bank Transfer Details */}
      <section className={styles.bankTransfer}>
        <div className={styles.bankBox}>
          <h3>Bank Transfer (Nigeria)</h3>
          <p>You can also donate directly to our bank account:</p>
          <div className={styles.bankDetails}>
            <p><strong>Bank:</strong> First Bank of Nigeria</p>
            <p><strong>Account Name:</strong> Idoma Medical Doctors Foundation</p>
            <p><strong>Account Number:</strong> 1234567890</p>
            <p><strong>Sort Code:</strong> 011234567</p>
          </div>
          <p className={styles.note}>Please email your teller to secretary@imdf.org for receipting.</p>
        </div>
      </section>

      {/* Transparency Section */}
      <section className={styles.transparency}>
        <SectionTitle title="Transparency" subtitle="We are accountable" align="center" />
        <p className={styles.transparencyText}>
          IMDF is committed to the highest standards of financial accountability. Our accounts are audited annually and available to members and donors upon request.
        </p>
        <div className={styles.reportLinks}>
          <Link to="#">
            <Button variant="outline" size="small">Download 2024 Annual Report (PDF)</Button>
          </Link>
          <Link to="#">
            <Button variant="outline" size="small">View Financial Summary</Button>
          </Link>
        </div>
      </section>

      {/* FAQ Teaser */}
      <section className={styles.faq}>
        <SectionTitle title="Frequently Asked Questions" subtitle="About giving" align="center" />
        <div className={styles.faqGrid}>
          <div className={styles.faqItem}>
            <h4>Is my donation tax-deductible?</h4>
            <p>IMDF is registered with the Nigerian Corporate Affairs Commission. Tax receipts are issued for all donations.</p>
          </div>
          <div className={styles.faqItem}>
            <h4>Can I donate from outside Nigeria?</h4>
            <p>Yes, we accept international donations via PayPal and bank transfers. Please contact us for details.</p>
          </div>
          <div className={styles.faqItem}>
            <h4>How are funds used?</h4>
            <p>Donations fund medical outreaches, journal publications, and community health programs. Over 85% of funds go directly to programs.</p>
          </div>
          <div className={styles.faqItem}>
            <h4>Can I specify where my donation goes?</h4>
            <p>Yes, you can designate your gift to a specific program (e.g., outreach, journal, equipment).</p>
          </div>
        </div>
        <div className={styles.faqMore}>
          <Link to="/contact">
            <Button variant="primary">More Questions? Contact Us</Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Donate;